import A from '../../actions/actionTypes';
import dataReducerGenerator from './dataReducerGenerator';
import { user } from './basicElements';
import uniq from '../../utils/uniq';

function updateFollowedGroups(state, action) {
    const id = action.follow.currentUserId;
    const oldUser = state[id] || {};
    const oldGroups = oldUser.groups || [];
    const groups = action.follow.isFollowing
        ? uniq([...oldGroups, action.follow.id])
        : oldUser.groups.filter(g => action.follow.id !== g);

    return {
        [id]: { ...oldUser, groups },
    };
}

export default (state = {}, action) => {
    const defaultUserReducer = dataReducerGenerator('users', user);

    switch (action.type) {
        case A.FOLLOW_TOGGLE_SUCCESS:
            if (action.follow && action.follow.type === 'groups') {
                return Object.assign({}, state, updateFollowedGroups(state, action));
            }
        default:
            return defaultUserReducer(state, action);
    }
}



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/data/users.js